//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const ERROR_ALERTS_CLASS = 'error-alerts-active';
  const content = angular.module('curalate');

  content.component('errorAlerts', {
    template: '<div class="error-alerts-bar cu-pos-fixed cu-text-center cu-text-white cu-valign-children-middle">' +
                        '<cu-icon class="cu-mr-2" name="alarm"></cu-icon>' +
                        '<span>{{$ctrl.model.message}}' +
                            ' <a ng-if="$ctrl.model.linkText && $ctrl.model.linkTarget" ' +
                                'class="cu-alert-link" ng-href="{{ $ctrl.model.linkTarget }}">{{$ctrl.model.linkText}}</a>' +
                        '</span>' +
                    '</div>',
    controller: [
      '$document',
      'SystemAlertsService',
      function(
                $document,
                SystemAlertsService,
            ) {
        this.active = false;
        this.model = {};

        this.updateActive = function(newVal) {
          const oldVal = this.active;
          this.active = newVal;

          if (newVal && !oldVal) {
            $document[0].body.classList.add(ERROR_ALERTS_CLASS);
          } else if (!newVal && oldVal) {
            $document[0].body.classList.remove(ERROR_ALERTS_CLASS);
          }
        };

        this.$onInit = function() {
          const self = this;
          // For now, only one Alert can occur per page load.
          SystemAlertsService.getErrorAlerts().then((alerts) => {
            if (alerts.length > 0) {
              self.model = alerts[0];
              const linkTarget = self.model.linkTarget;
              // The LWS backend returns an old `/settings` URL for some alerts. And our frontend doesn't pass the # through the redirect.
              // So let's patch those routes here to make the redirect work.
              // TODO: Send proper URLs on the backend.
              self.model.linkTarget = linkTarget && linkTarget.replace(/^\/settings#/, '/account-settings/social-media#'); // TODO do the redirection to my-account or analytics-providers based on the part after #
              self.updateActive(true);
            }
          });
        };

        this.$onDestroy = function() {
          this.updateActive(false);
        };
      },
    ],
  });
})();
